module.exports = __webpack_public_path__ + "static/media/43-2.ccdc1bed.mp3";